/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';

/**
 * Represents a prize in an NFT reward.
 * @export
 * @interface NftRewardPrize
 */
export interface NftRewardPrize {
    /**
     * 
     * @type {string}
     * @memberof NftRewardPrize
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof NftRewardPrize
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof NftRewardPrize
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof NftRewardPrize
     */
    prizeRevealName: string;
    /**
     * 
     * @type {number}
     * @memberof NftRewardPrize
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof NftRewardPrize
     */
    wonQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof NftRewardPrize
     */
    sortOrder?: number;
    /**
     * number of times this current reward has been redeemed for this prize to be available
     * @type {number}
     * @memberof NftRewardPrize
     */
    onlyAvailableAfterWins?: number;
    /**
     * 
     * @type {RewardConfigResponse}
     * @memberof NftRewardPrize
     */
    rewardConfig: RewardConfigResponse;
}

/**
 * Check if a given object implements the NftRewardPrize interface.
 */
export function instanceOfNftRewardPrize(value: object): value is NftRewardPrize {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('prizeRevealName' in value) || value['prizeRevealName'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('wonQuantity' in value) || value['wonQuantity'] === undefined) return false;
    if (!('rewardConfig' in value) || value['rewardConfig'] === undefined) return false;
    return true;
}

export function NftRewardPrizeFromJSON(json: any): NftRewardPrize {
    return NftRewardPrizeFromJSONTyped(json, false);
}

export function NftRewardPrizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftRewardPrize {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'prizeRevealName': json['prizeRevealName'],
        'quantity': json['quantity'],
        'wonQuantity': json['wonQuantity'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'onlyAvailableAfterWins': json['onlyAvailableAfterWins'] == null ? undefined : json['onlyAvailableAfterWins'],
        'rewardConfig': RewardConfigResponseFromJSON(json['rewardConfig']),
    };
}

export function NftRewardPrizeToJSON(json: any): NftRewardPrize {
    return NftRewardPrizeToJSONTyped(json, false);
}

export function NftRewardPrizeToJSONTyped(value?: NftRewardPrize | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'prizeRevealName': value['prizeRevealName'],
        'quantity': value['quantity'],
        'wonQuantity': value['wonQuantity'],
        'sortOrder': value['sortOrder'],
        'onlyAvailableAfterWins': value['onlyAvailableAfterWins'],
        'rewardConfig': RewardConfigResponseToJSON(value['rewardConfig']),
    };
}

